import { Label } from 'src/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from 'src/components/ui/select';
import { Switch } from 'src/components/ui/switch';
import type { ConfigRendererProps } from './types';

const schemaOptions = [
  { value: 'ap_invoice', label: 'AP Invoice' },
  { value: 'purchase_order', label: 'Purchase Order' },
];

export function ExtractDocumentContentConfigRenderer({
  config,
  onConfigChange,
}: ConfigRendererProps) {
  const currentSchemaType =
    typeof config.extendSchemaType === 'string' ? config.extendSchemaType : '';
  const skipClassificationCheck = Boolean(config.skipClassificationCheck);

  const handleSchemaChange = (value: string) => {
    onConfigChange({
      ...config,
      extendSchemaType: value || undefined,
    });
  };

  const handleSkipClassificationToggle = (checked: boolean) => {
    onConfigChange({
      ...config,
      skipClassificationCheck: checked,
    });
  };

  return (
    <div className="space-y-5">
      <div className="space-y-2">
        <div className="flex items-center justify-between gap-2">
          <Label htmlFor="extendSchemaType" className="text-sm font-medium">
            Extend AI schema
          </Label>
          <p className="text-[11px] text-muted-foreground">
            Optional. Defaults per workflow template.
          </p>
        </div>
        <Select value={currentSchemaType} onValueChange={handleSchemaChange}>
          <SelectTrigger id="extendSchemaType" className="w-full">
            <SelectValue placeholder="Select a schema" />
          </SelectTrigger>
          <SelectContent>
            {schemaOptions.map((option) => (
              <SelectItem key={option.value} value={option.value}>
                {option.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
        <p className="text-xs text-muted-foreground">
          Determines which Extend AI extraction schema to use. Leave blank to
          use the template default.
        </p>
      </div>

      <div className="space-y-2 rounded-md border p-3">
        <div className="flex items-center justify-between gap-3">
          <div>
            <p className="text-sm font-medium">Skip classification check</p>
            <p className="text-xs text-muted-foreground">
              Process documents even if they are unclassified or marked OTHER.
            </p>
          </div>
          <Switch
            checked={skipClassificationCheck}
            onCheckedChange={handleSkipClassificationToggle}
            aria-label="Skip classification check"
          />
        </div>
        <p className="text-[11px] text-muted-foreground">
          Useful for legacy ingestion paths where classification is handled
          elsewhere.
        </p>
      </div>
    </div>
  );
}
